// extracted by mini-css-extract-plugin
module.exports = {"container":"container--45e5c","withPlaceHolder":"withPlaceHolder--1681e"};